import React from "react";
import * as Image from "../../assets/images";

export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer
      style={{
        width: "100%",
        background: "#E6F4EA",
        boxShadow: "0 -2px 8px rgba(0, 0, 0, 0.06)",
        flexShrink: 0,
      }}
    >
      <div
        style={{
          maxWidth: "1400px",
          margin: "0 auto",
          padding: "10px 20px",
          display: "grid",
          gridTemplateColumns: "1fr auto",
          alignItems: "center",
          gap: 12,
        }}
      >
        <div
          style={{
            textAlign: "center",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            gap: 12,
            flexWrap: "wrap",
          }}
        >
          <img
            src={Image.copyimg}
            alt="Quation"
            style={{
              height: 48,
              objectFit: "contain",
            }}
          />

          <span
            style={{
              fontFamily: "Poppins, sans-serif",
              fontSize: 15.5,
              fontWeight: 500,
              color: "#0c3c54",
              letterSpacing: "0.2px",
              lineHeight: 1.3,
              marginBottom: "0.5vh"
            }}
          >
            © 2025 Quation Solutions Pvt. Ltd. All rights reserved.
          </span>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 3,
          }}
        >
          <button
            onClick={scrollToTop}
            aria-label="Scroll to top"
            style={{
              width: 32,
              height: 32,
              borderRadius: "50%",
              border: "none",
              cursor: "pointer",
              background: "#E06639",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 2px 8px rgba(230, 111, 81, 0.3)",
              transition: "transform 0.2s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-1px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
            }}
          >
            <iconify-icon
              icon="tabler:arrow-up"
              style={{ fontSize: 18, color: "#fff" }}
            />
          </button>

          <span
            style={{
              fontSize: 9,
              fontWeight: 600,
              letterSpacing: "0.6px",
              color: "#c64b2d",
              fontFamily: "Poppins, sans-serif",
              textTransform: "uppercase",
            }}
          >
            Scroll To Top
          </span>
        </div>
      </div>
    </footer>
  );
}
